module.exports = __webpack_public_path__ + "img/chinesecompany152.b9b3abfb.png";